import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-licensure-and-training-attendance-rec',
  imports: [PillarPagesTemp],
  templateUrl: './licensure-and-training-attendance-rec.html',
  styleUrl: './licensure-and-training-attendance-rec.scss',
})
export class LicensureAndTrainingAttendanceRec {

}
